const SCHEDULE_COLUMNS = [
  { key: "title", label: "Título", width: 40 },
  { key: "businessClient", label: "Cliente", width: 22 },
  { key: "city", label: "Localidade", width: 22 },
  { key: "dateTime", label: "Data/Hora", width: 20 },
  { key: "status", label: "Estado", width: 16 },
];

const DEVICE_COLUMNS = [
  { key: "device", label: "Dispositivo", width: 34 },
  { key: "count", label: "Mídias recebidas", width: 22 },
];

const WINDOW_COLUMNS = [
  { key: "businessClient", label: "Cliente", width: 26 },
  { key: "identifier", label: "Identificador", width: 18 },
  { key: "status", label: "Status", width: 14 },
];

const SCENARIO_COLUMNS = [
  { key: "businessClient", label: "Cliente", width: 26 },
  { key: "scenario", label: "Cenário", width: 14 },
  { key: "description", label: "Descrição", width: 50 },
  { key: "status", label: "Status", width: 14 },
];

const KPI_COLUMNS = [
  { key: "label", label: "Indicador", width: 34 },
  { key: "value", label: "Valor", width: 16 },
  { key: "delta", label: "Variação vs período anterior", width: 34 },
];

const STATUS_SUMMARY_COLUMNS = [
  { key: "label", label: "Status", width: 20 },
  { key: "count", label: "Quantidade", width: 16 },
  { key: "pct", label: "% do total", width: 14 },
];

const CITY_COLUMNS = [
  { key: "label", label: "Cidade", width: 24 },
  { key: "count", label: "Agendamentos", width: 18 },
];

const HEADER_FILL = { type: "pattern", pattern: "solid", fgColor: { argb: "FF17324D" } };
const HEADER_FONT = { bold: true, color: { argb: "FFFFFFFF" } };

function filename(extension) {
  const date = new Date().toISOString().slice(0, 10);
  return `relatorio-dashboard-${date}.${extension}`;
}

function downloadBlob(blob, targetFilename) {
  if (navigator.msSaveOrOpenBlob) {
    navigator.msSaveOrOpenBlob(blob, targetFilename);
    return;
  }
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = targetFilename;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  window.setTimeout(() => {
    link.remove();
    URL.revokeObjectURL(url);
  }, 1000);
}

function printableDate(value) {
  if (!(value instanceof Date)) return "—";
  return new Intl.DateTimeFormat("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  }).format(value);
}

// Mesmos números exibidos no painel "Mídias e recebimento (return-channel)" do Dashboard.
function mediaSummaryLines(media) {
  return [
    ["Tamanho médio por mídia", `${media.avgSizeMB} MB`],
    ["Mídias recebidas no período", `${media.receivedInPeriod}`],
    ["Dispositivos únicos que confirmaram", `${media.uniqueDevices}`],
    ["Armazenamento recebido no período", `${media.storageInPeriodGB} GB`],
  ];
}

function addSchedulesSheet(workbook, rows) {
  const worksheet = workbook.addWorksheet("Agendamentos", {
    views: [{ state: "frozen", ySplit: 1 }],
    properties: { defaultRowHeight: 20 },
  });
  worksheet.columns = SCHEDULE_COLUMNS.map((column) => ({
    header: column.label,
    key: column.key,
    width: column.width,
  }));
  worksheet.addRows(rows);
  worksheet.autoFilter = `A1:E${Math.max(rows.length + 1, 1)}`;

  worksheet.getRow(1).height = 26;
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = HEADER_FONT;
    cell.fill = HEADER_FILL;
    cell.alignment = { vertical: "middle", horizontal: "left" };
  });
  worksheet.eachRow((row, rowNumber) => {
    if (rowNumber === 1) return;
    row.eachCell((cell) => {
      cell.alignment = { vertical: "middle", horizontal: "left", wrapText: true };
    });
  });
}

function addDevicesSheet(workbook, media) {
  const worksheet = workbook.addWorksheet("Dispositivos", {
    properties: { defaultRowHeight: 20 },
  });
  worksheet.getColumn(1).width = DEVICE_COLUMNS[0].width;
  worksheet.getColumn(2).width = DEVICE_COLUMNS[1].width;

  mediaSummaryLines(media).forEach(([label, value]) => {
    const row = worksheet.addRow([label, value]);
    row.getCell(1).font = { bold: true };
  });
  worksheet.addRow([]);

  const headerRow = worksheet.addRow(DEVICE_COLUMNS.map((column) => column.label));
  headerRow.eachCell((cell) => {
    cell.font = HEADER_FONT;
    cell.fill = HEADER_FILL;
    cell.alignment = { vertical: "middle", horizontal: "left" };
  });

  const devices = media.topDevices || [];
  devices.forEach((device) => worksheet.addRow([device.device, device.count]));
  if (devices.length) {
    worksheet.autoFilter = `A${headerRow.number}:B${headerRow.number + devices.length}`;
  }
}

// Escreve um bloco "título + tabela" a partir de startRow e devolve a próxima
// linha livre - permite empilhar duas tabelas independentes na mesma aba.
function addTableBlock(worksheet, startRow, title, columns, rows) {
  const titleRow = worksheet.getRow(startRow);
  titleRow.getCell(1).value = title;
  titleRow.getCell(1).font = { bold: true, size: 13 };

  const headerRowNumber = startRow + 1;
  const headerRow = worksheet.getRow(headerRowNumber);
  columns.forEach((column, index) => {
    const cell = headerRow.getCell(index + 1);
    cell.value = column.label;
    cell.font = HEADER_FONT;
    cell.fill = HEADER_FILL;
    cell.alignment = { vertical: "middle", horizontal: "left" };
  });

  rows.forEach((row, rowIndex) => {
    const dataRow = worksheet.getRow(headerRowNumber + 1 + rowIndex);
    columns.forEach((column, colIndex) => {
      dataRow.getCell(colIndex + 1).value = row[column.key];
    });
  });

  return headerRowNumber + rows.length + 2;
}

function addSummarySheet(workbook, summary) {
  const worksheet = workbook.addWorksheet("Resumo", {
    properties: { defaultRowHeight: 20 },
  });
  worksheet.getColumn(1).width = 34;
  worksheet.getColumn(2).width = 20;
  worksheet.getColumn(3).width = 34;

  const periodRow = worksheet.getRow(1);
  periodRow.getCell(1).value = `Período: ${summary.periodLabel}`;
  periodRow.getCell(1).font = { bold: true, size: 13 };

  let nextRow = addTableBlock(worksheet, 3, "Indicadores do período", KPI_COLUMNS, summary.kpis);
  nextRow = addTableBlock(
    worksheet,
    nextRow,
    "Status dos agendamentos no período",
    STATUS_SUMMARY_COLUMNS,
    summary.statusBreakdown,
  );
  addTableBlock(worksheet, nextRow, "Agendamentos por cidade", CITY_COLUMNS, summary.topCities);
}

function addConfigSheet(workbook, scenarioConfig) {
  const worksheet = workbook.addWorksheet("Configurações", {
    properties: { defaultRowHeight: 20 },
  });
  worksheet.getColumn(1).width = 26;
  worksheet.getColumn(2).width = 20;
  worksheet.getColumn(3).width = 50;
  worksheet.getColumn(4).width = 14;

  const nextRow = addTableBlock(
    worksheet,
    1,
    "Identificadores de cliente ativos",
    WINDOW_COLUMNS,
    scenarioConfig.windows,
  );
  addTableBlock(worksheet, nextRow, "Cenários de recebimento ativos", SCENARIO_COLUMNS, scenarioConfig.scenarios);
}

export async function exportScheduleExcel(scheduleRows, media, scenarioConfig, summary) {
  const excelModule = await import("exceljs");
  const ExcelJS = excelModule.default || excelModule;
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Datacasting";
  workbook.created = new Date();

  addSummarySheet(workbook, summary);
  addSchedulesSheet(workbook, scheduleRows);
  addDevicesSheet(workbook, media);
  addConfigSheet(workbook, scenarioConfig);

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob(
    [new Uint8Array(buffer)],
    { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" },
  );
  downloadBlob(blob, filename("xlsx"));
}

export async function exportSchedulePdf(scheduleRows, media, scenarioConfig, summary) {
  const [{ jsPDF }, tableModule] = await Promise.all([
    import("jspdf"),
    import("jspdf-autotable"),
  ]);
  const autoTable = tableModule.default || tableModule.autoTable;
  const documentPdf = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });

  documentPdf.setFont("helvetica", "bold");
  documentPdf.setFontSize(16);
  documentPdf.text("Resumo do período", 14, 16);
  documentPdf.setFont("helvetica", "normal");
  documentPdf.setFontSize(9);
  documentPdf.text(`Período: ${summary.periodLabel}`, 14, 22);

  documentPdf.setFont("helvetica", "bold");
  documentPdf.setFontSize(11);
  documentPdf.text("Indicadores do período", 14, 30);
  autoTable(documentPdf, {
    startY: 34,
    head: [KPI_COLUMNS.map((column) => column.label)],
    body: summary.kpis.map((row) => KPI_COLUMNS.map((column) => row[column.key] ?? "")),
    theme: "striped",
    margin: { left: 14, right: 14 },
    styles: { font: "helvetica", fontSize: 8, cellPadding: 2, overflow: "linebreak" },
    headStyles: { fillColor: [23, 50, 77], textColor: 255, fontStyle: "bold" },
  });

  const statusTitleY = documentPdf.lastAutoTable.finalY + 12;
  documentPdf.setFont("helvetica", "bold");
  documentPdf.setFontSize(11);
  documentPdf.text("Status dos agendamentos no período", 14, statusTitleY);
  autoTable(documentPdf, {
    startY: statusTitleY + 4,
    head: [STATUS_SUMMARY_COLUMNS.map((column) => column.label)],
    body: summary.statusBreakdown.map((row) => STATUS_SUMMARY_COLUMNS.map((column) => row[column.key] ?? "")),
    theme: "striped",
    margin: { left: 14, right: 14 },
    styles: { font: "helvetica", fontSize: 8, cellPadding: 2 },
    headStyles: { fillColor: [23, 50, 77], textColor: 255, fontStyle: "bold" },
  });

  const cityTitleY = documentPdf.lastAutoTable.finalY + 12;
  documentPdf.setFont("helvetica", "bold");
  documentPdf.setFontSize(11);
  documentPdf.text("Agendamentos por cidade", 14, cityTitleY);
  autoTable(documentPdf, {
    startY: cityTitleY + 4,
    head: [CITY_COLUMNS.map((column) => column.label)],
    body: summary.topCities.map((row) => CITY_COLUMNS.map((column) => row[column.key] ?? "")),
    theme: "striped",
    margin: { left: 14, right: 14, bottom: 14 },
    styles: { font: "helvetica", fontSize: 8, cellPadding: 2 },
    headStyles: { fillColor: [23, 50, 77], textColor: 255, fontStyle: "bold" },
  });

  documentPdf.addPage();
  documentPdf.setFont("helvetica", "bold");
  documentPdf.setFontSize(16);
  documentPdf.text("Relatório de agendamentos", 14, 16);
  documentPdf.setFont("helvetica", "normal");
  documentPdf.setFontSize(9);
  documentPdf.text(`${scheduleRows.length} registros exportados em ${printableDate(new Date())}`, 14, 22);

  autoTable(documentPdf, {
    startY: 28,
    head: [SCHEDULE_COLUMNS.map((column) => column.label)],
    body: scheduleRows.map((row) => SCHEDULE_COLUMNS.map((column) => row[column.key] || "")),
    theme: "striped",
    margin: { left: 14, right: 14, bottom: 14 },
    styles: { font: "helvetica", fontSize: 8, cellPadding: 2, overflow: "linebreak" },
    headStyles: { fillColor: [23, 50, 77], textColor: 255, fontStyle: "bold" },
    columnStyles: {
      0: { cellWidth: 90 },
      1: { cellWidth: 50 },
      2: { cellWidth: 50 },
      3: { cellWidth: 45 },
      4: { cellWidth: 30 },
    },
  });

  documentPdf.addPage();
  documentPdf.setFont("helvetica", "bold");
  documentPdf.setFontSize(16);
  documentPdf.text("Dispositivos e mídias (return-channel)", 14, 16);
  documentPdf.setFont("helvetica", "normal");
  documentPdf.setFontSize(9);
  let cursorY = 24;
  mediaSummaryLines(media).forEach(([label, value]) => {
    documentPdf.text(`${label}: ${value}`, 14, cursorY);
    cursorY += 6;
  });

  autoTable(documentPdf, {
    startY: cursorY + 4,
    head: [DEVICE_COLUMNS.map((column) => column.label)],
    body: (media.topDevices || []).map((device) => [device.device, String(device.count)]),
    theme: "striped",
    margin: { left: 14, right: 14, bottom: 14 },
    styles: { font: "helvetica", fontSize: 8, cellPadding: 2, overflow: "linebreak" },
    headStyles: { fillColor: [23, 50, 77], textColor: 255, fontStyle: "bold" },
    columnStyles: {
      0: { cellWidth: 100 },
      1: { cellWidth: 60 },
    },
  });

  documentPdf.addPage();
  documentPdf.setFont("helvetica", "bold");
  documentPdf.setFontSize(16);
  documentPdf.text("Configurações do receptor", 14, 16);
  documentPdf.setFont("helvetica", "normal");
  documentPdf.setFontSize(9);
  documentPdf.text(`Exportado em ${printableDate(new Date())}`, 14, 22);

  documentPdf.setFont("helvetica", "bold");
  documentPdf.setFontSize(11);
  documentPdf.text("Identificadores de cliente ativos", 14, 30);
  autoTable(documentPdf, {
    startY: 34,
    head: [WINDOW_COLUMNS.map((column) => column.label)],
    body: scenarioConfig.windows.map((row) => WINDOW_COLUMNS.map((column) => row[column.key] ?? "")),
    theme: "striped",
    margin: { left: 14, right: 14 },
    styles: { font: "helvetica", fontSize: 8, cellPadding: 2, overflow: "linebreak" },
    headStyles: { fillColor: [23, 50, 77], textColor: 255, fontStyle: "bold" },
  });

  const scenariosTitleY = documentPdf.lastAutoTable.finalY + 12;
  documentPdf.setFont("helvetica", "bold");
  documentPdf.setFontSize(11);
  documentPdf.text("Cenários de recebimento ativos", 14, scenariosTitleY);
  autoTable(documentPdf, {
    startY: scenariosTitleY + 4,
    head: [SCENARIO_COLUMNS.map((column) => column.label)],
    body: scenarioConfig.scenarios.map((row) => SCENARIO_COLUMNS.map((column) => row[column.key] ?? "")),
    theme: "striped",
    margin: { left: 14, right: 14, bottom: 14 },
    styles: { font: "helvetica", fontSize: 8, cellPadding: 2, overflow: "linebreak" },
    headStyles: { fillColor: [23, 50, 77], textColor: 255, fontStyle: "bold" },
    columnStyles: {
      0: { cellWidth: 60 },
      1: { cellWidth: 30 },
      2: { cellWidth: 130 },
      3: { cellWidth: 30 },
    },
  });

  const pageCount = documentPdf.getNumberOfPages();
  for (let page = 1; page <= pageCount; page += 1) {
    documentPdf.setPage(page);
    documentPdf.setFont("helvetica", "normal");
    documentPdf.setFontSize(8);
    documentPdf.setTextColor(100);
    documentPdf.text(`Página ${page} de ${pageCount}`, 283, 200, { align: "right" });
  }
  const blob = documentPdf.output("blob");
  downloadBlob(blob, filename("pdf"));
}
